
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.255 28.024a9.334 9.334 0 00-9.27 9.27 1.302 1.302 0 102.604 0 6.73 6.73 0 016.666-6.666 1.302 1.302 0 100-2.604z","fill":"#C1AB8E"}}),_c('path',{attrs:{"d":"M56.866 53.088l-8.893-8.932a2.236 2.236 0 00-.208-.144 13.291 13.291 0 00-9.136-19.805 13.3 13.3 0 00-11.736 3.686 13.292 13.292 0 0016.12 20.872c.043.071.09.141.143.208l8.932 8.932a1.302 1.302 0 001.836 0l2.981-2.981c.495-.52.477-1.34-.039-1.836zM25.682 37.294a10.637 10.637 0 1118.115 7.619 10.637 10.637 0 01-18.115-7.618zm27.343 17.8l-7.083-7.097 1.133-1.133 7.096 7.083-1.146 1.146z","fill":"#fff"}})])
          )
        }
      }
    